module.exports = __webpack_public_path__ + "img/email_updated_dark.1d46342b.svg";